export const REDIRECT_PARAM = 'redirectUnauthorized';
